import { useOutletContext } from "react-router-dom";

import { KnowledgeBaseOutletContext } from "./types";

export const useKnowledgeBaseOutletContext = () => {
  const context = useOutletContext<KnowledgeBaseOutletContext | null>();

  if (!context) {
    throw new Error(
      "Компонент базы знаний отрендерен вне KnowledgeBaseLayout — в нём нет outlet-контекста",
    );
  }

  return context;
};
